import { createContext } from 'react'
import type { AiOperatingMode, AiTierId } from '../types/ai'

export type { AiOperatingMode } from '../types/ai'
export type AiContextTab = 'NODES' | 'CHECKLISTS' | 'DIFFS'
export type AiInteractionPhase = 'IDLE' | 'PREFLIGHT' | 'STREAMING'

export interface AiChatContextValue {
  operatingMode: AiOperatingMode
  setOperatingMode: (mode: AiOperatingMode) => void
  /** Sub-state of the CREATE tab. When true the AI plans only (read-only,
   * never writes through the Review queue). When false the AI prepares
   * changes for the standard Review + Save flow. Ignored on the EXECUTE tab. */
  isPlanningMode: boolean
  setIsPlanningMode: (value: boolean) => void
  activeContextTab: AiContextTab
  setActiveContextTab: (tab: AiContextTab) => void
  isSidecarOpen: boolean
  setIsSidecarOpen: (isOpen: boolean) => void
  isMobileMenuOpen: boolean
  setIsMobileMenuOpen: (isOpen: boolean) => void
  phase: AiInteractionPhase
  setPhase: (phase: AiInteractionPhase) => void
  activeNodeId: string | null
  setActiveNodeId: (nodeId: string | null) => void
  /**
   * User-selected quality tier for the current chat thread. Frozen onto the
   * outgoing turn at send time. See docs/pricing/line-tier-integration-plan.md §3a.
   * `null` = not yet resolved (initial mount, before hook computes precedence).
   */
  tier: AiTierId | null
  setTier: (tier: AiTierId) => void
}

export const AiChatContext = createContext<AiChatContextValue | undefined>(undefined)
